function clampNumber(value, min, max) {
    return Math.max(min, Math.min(max, Number(value) || 0));
}

function qualityFromRange(value, max, invert = false) {
    if (value === null || value === undefined || Number.isNaN(value)) return null;
    const normalized = (clampNumber(value, 0, max) / max) * 100;
    return invert ? (100 - normalized) : normalized;
}

export function qualityFromQoo(score) {
    return qualityFromRange(score, 100, false);
}

export function qualityFromRtt(ms) {
    return qualityFromRange(ms, 200, true);
}

export function qualityFromRetransmit(percent) {
    return qualityFromRange(percent, 10, true);
}

export function qualityFromCapacity(percent) {
    return qualityFromRange(percent, 100, true);
}

const SENTIMENT_UP_THRESHOLD = 53;
const SENTIMENT_DOWN_THRESHOLD = 44;

export function sentimentState(quality) {
    if (quality === null) {
        return {
            icon: "fa-minus",
            tone: "text-muted",
            label: "No data",
            key: "nodata",
        };
    }
    if (quality >= SENTIMENT_UP_THRESHOLD) {
        return {
            icon: "fa-thumbs-up",
            tone: "text-success",
            label: "Healthy",
            key: "healthy",
        };
    }
    if (quality <= SENTIMENT_DOWN_THRESHOLD) {
        return {
            icon: "fa-thumbs-down",
            tone: "text-danger",
            label: "Needs attention",
            key: "attention",
        };
    }
    return {
        icon: "fa-minus",
        tone: "text-warning",
        label: "Watch",
        key: "watch",
    };
}
